import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { Button, TextField, Box, Typography, CircularProgress, Dialog, IconButton, Chip } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';  // Add icon for the close button
import showToast from "../Hot-Toast/showToast";
import { useTMutation } from "../../utils/useTMutation";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { useNavigate } from "react-router-dom";

const payoutSchema = z.object({
    name: z.string().min(2, "Name is required"),
    amount: z.coerce.number().min(1, "Amount must be at least 1 USD"),
    routingNumber: z.string().min(6, "Routing number must be at least 6 digits"),
    accountNumber: z.string().min(4, "Account number must be at least 4 digits"),
});

export const PayoutToBankForm = ({ open, onClose, data }) => {
    console.log("data", data);
    const navigate = useNavigate();
    const BankAccounts = data?.BankAccounts;
    const Clinician = data?.Clinician;
    const Amount = data?.Amount;
    const TotalHours = data?.TotalHours;
    const STRIPE_ACCOUNT_ID = data?.STRIPE_ACCOUNT_ID;
    const SelectedRows = data?.SelectedRows;
    const [selectedBank, setSelectedBank] = useState(BankAccounts[0] || null);
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue, // to set default test values
    } = useForm({ resolver: zodResolver(payoutSchema) });

    const mutation = useTMutation("/payment/payout-external-bank", "post", (data) => {
        data.stripeBankAccountID = selectedBank?.stripeBankAccountID;

        showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
        if (data.STATUS) {
            reset();
            onClose();
            navigate(-1)
            // navigate("/facility/timesheet/view-clinicians/" + clinicianJobTimeSheet?.jobID);
        }
    });

    useEffect(() => {
        if (BankAccounts.length > 0) {
            setSelectedBank(BankAccounts[0]);
            setValue("amount", Amount);
            setValue("name", BankAccounts[0].accountHolderName);
            setValue("routingNumber", BankAccounts[0].routingNumber);
            setValue("accountNumber", BankAccounts[0].accountNumber);
        } else {
            setValue("amount", 0);
            setValue("name", "John Doe");
            setValue("routingNumber", "110000000");
            setValue("accountNumber", "000123456789");
        }
    }, [setValue, BankAccounts, Amount]);

    const onSubmit = async (data) => {
        data.recipientEmail = Clinician.EMAIL_ADDRESS;
        data.clinicianId = Clinician.ID;
        data.STRIPE_ACCOUNT_ID = STRIPE_ACCOUNT_ID;
        data.totalHours = TotalHours;
        data.selectedRows = SelectedRows;
        await mutation.mutateAsync(data);

    };

    const handleClose = () => {
        if (onClose) {
            onClose(); // This ensures the parent component can close the dialog
        }
    };
    const handleSelectBank = (selectedChip) => {
        setSelectedBank(selectedChip);
        setValue("name", selectedChip.accountHolderName);
        setValue("routingNumber", selectedChip.routingNumber);
        setValue("accountNumber", selectedChip.accountNumber);
    };
    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <Box p={3}>
                {/* Close button at the top */}
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        zIndex: 1
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Typography variant="h6" gutterBottom>
                    Send Payout
                </Typography>

                {BankAccounts.length > 0 && (
                    <Box mb={2}>
                        <Typography variant="body1" style={{ fontWeight: 'bold' }}>Clinician Bank Details</Typography>
                        <Typography variant="body2" color="textSecondary" gutterBottom>
                            Choose a saved clinician's bank account to send money.
                        </Typography>
                        <Box display="flex" gap={1} flexWrap="wrap">
                            {BankAccounts.map((bank, index) => (
                                <Chip
                                    key={index}
                                    label={bank.bankName}
                                    icon={<AccountBalanceIcon />}
                                    onClick={() => handleSelectBank(bank)}
                                    sx={{
                                        cursor: "pointer",
                                        backgroundColor: selectedBank === bank ? "#d0f0c0" : "#f5f5f5",
                                    }}
                                />
                            ))}
                        </Box>
                    </Box>
                )}

                <form onSubmit={handleSubmit(onSubmit)}>
                    <TextField fullWidth margin="normal" InputLabelProps={{ shrink: true }} label="Amount (USD)" type="number" value={Amount} disabled error={!!errors.amount} helperText={errors.amount?.message} />
                    <TextField fullWidth margin="normal" label="Full Name" InputLabelProps={{ shrink: true }} {...register("name")} error={!!errors.name} helperText={errors.name?.message} />
                    <TextField fullWidth margin="normal" label="Routing Number" {...register("routingNumber")} error={!!errors.routingNumber} helperText={errors.routingNumber?.message} />
                    <TextField fullWidth margin="normal" label="Account Number" {...register("accountNumber")} error={!!errors.accountNumber} helperText={errors.accountNumber?.message} />
                    <Button type="submit" variant="contained" color="primary" fullWidth disabled={mutation.isPending} sx={{ mt: 2 }}>
                        {mutation.isPending ? <CircularProgress size={24} /> : "Send Money"}
                    </Button>
                </form>
            </Box>
        </Dialog>
    );
};
